// extracted by mini-css-extract-plugin
export default {"item-list":"CartItemList_item-list__UqUjQ"};